import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ConfigurableGridFormViewComponentController,
  ToggleButtonDefinition,
} from "../../../records/views/configurableGridFormView/controller";
import { ConfigurableGridFormViewService } from "../../../records/views/configurableGridFormView/service";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../machineConfigurationCellClassService";

export const vsServiceName = "machineConfigurableFormViewService";
export class MachineConfigurableGridFormViewService extends ConfigurableGridFormViewService {
  static $inject = [MachineConfigurationCellClassServiceName, "environment"];
  constructor(
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService,
    private readonly environment: { Date: Date }
  ) {
    super();
  }

  futureAndCurrentConfigurationsOnlyToggleButton(
    initiallyChecked: boolean
  ): ToggleButtonDefinition {
    return {
      id: "futureAndCurrentConfigurationsOnly",
      text: "Show Future and Current Configurations Only",
      checked: initiallyChecked,
      onChanged: (
        toggleButton: ToggleButtonDefinition,
        controller: ConfigurableGridFormViewComponentController
      ) => {
        controller.config.defaultQuery.CurrentConfigurationOrDateGreaterThanOrEqualTo =
          toggleButton.checked ? this.environment.Date : undefined;
      },
    };
  }

  currentConfigurationOnlyToggleButton(
    initiallyChecked?: boolean
  ): ToggleButtonDefinition {
    return {
      id: "showPastConfigurations",
      text: "Show Past Configurations",
      checked: initiallyChecked ?? false,
      onChanged: (
        toggleButton: ToggleButtonDefinition,
        controller: ConfigurableGridFormViewComponentController
      ) => {
        const shouldStyle = toggleButton.checked ?? false;

        controller.config.defaultQuery.CurrentConfigurationOrDateGreaterThanOrEqualTo =
          toggleButton.checked ? undefined : this.environment.Date;
        this.machineConfigurationCellClassService.styleColumns(
          controller.config.gridConfiguration.columns ?? [],
          shouldStyle
        );
      },
    };
  }
}
